import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "text-gray-600 dark:text-gray-300" };
const _hoisted_2 = { class: "font-bold" };
const _hoisted_3 = /*#__PURE__*/ _createTextVNode("? ");
const _hoisted_4 = {
    key: 0,
    class: "text-sm-but-a-bit-smaller text-primary-900 dark:text-white"
};
const _hoisted_5 = { class: "flex flex-col mt-6" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.workspaces.invites_form')
};
import { computed, nextTick, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { useNewTeamStore } from '@/pinia_stores/newTeam';
import { useSeatsValidations } from '@/composables/seatsValidations';
import UserInput from '@/components/workspaces/UserInput.vue';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'InvitesForm',
    props: {
        isPartOfWorkspaceCreation: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const store = useNewTeamStore();
        const workspaceStore = useStore();
        const workspace = computed(() => workspaceStore.getters.workspace);
        const { users, invitesSearchTerm, seatsToBuy } = storeToRefs(store);
        const { displayableSeatsAvailable, displayableSeatsTaken, totalSeatsAvailable } = useSeatsValidations({
            selectedUsers: users,
            searchTerm: invitesSearchTerm,
            seatsToBuy,
            workspace: workspace
        });
        const isOverflown = ref(false);
        const selectedUsers = ref(null);
        watch(() => store.users, () => {
            nextTick(() => {
                const element = selectedUsers.value;
                isOverflown.value = !!element && element.scrollHeight > element.clientHeight;
            });
        });
        const userId = computed(() => workspaceStore.getters.session.id);
        const members = computed(() => {
            const invitesEmails = new Set(store.users.map((user) => user.email));
            return Array.from(workspace.value?.members ?? [])
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .filter((member) => member.id !== userId.value && !invitesEmails.has(member.email));
        });
        const hasSeatsAvailable = computed(() => props.isPartOfWorkspaceCreation || totalSeatsAvailable.value >= 0);
        const isWorkspaceOwner = computed(() => workspaceStore.getters.isWorkspaceOwner);
        const disallowExternalToWorkspace = computed(() => !isWorkspaceOwner.value && !hasSeatsAvailable.value);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("h1", _hoisted_1, [
                    _createTextVNode(_toDisplayString(_ctx.$t('who_belongs')) + " ", 1),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(store).teamName), 1),
                    _hoisted_3
                ]),
                (!__props.isPartOfWorkspaceCreation && _unref(isPricingEnabled))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('seats_available', {
                        taken: _unref(displayableSeatsTaken),
                        available: _unref(displayableSeatsAvailable)
                    })), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(UserInput, {
                        modelValue: _unref(store).users,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(store).users) = $event)),
                        "search-term": _unref(store).invitesSearchTerm,
                        "onUpdate:search-term": _cache[1] || (_cache[1] = ($event) => ((_unref(store).invitesSearchTerm) = $event)),
                        size: "sm",
                        users: _unref(members),
                        "disallow-external-to-workspace": _unref(disallowExternalToWorkspace)
                    }, null, 8, ["modelValue", "search-term", "users", "disallow-external-to-workspace"])
                ])
            ]));
        };
    }
});
